<template>
  <v-dialog v-model="dialog" :persistent="persistent" :max-width="max_width || 550" @click:outside="()=>persistent?false:close()">
    <v-card class="pa-20 fs1_dialog" :class="align || 'textAlignCenter'">
			<slot>
				<slot name="title">
					<h2 v-if="template=='warning'">
						<v-icon class="pulse_warning" style="vertical-align: text-top;">warning</v-icon>{{title || 'Advertencia'}}
					</h2>
					<template v-if="template=='unfilled'">
						<h1 class="dark-orange--text">Formulario incompleto.</h1>
						<br>
						<p>
							<v-icon class="pulse_warning">warning</v-icon>
							<fs1-span>
								<b>Hay información que aún no ha sido ingresada.</b>
							</fs1-span>
						</p>
					</template>
					<h2 v-if="!template">{{title}}</h2>
				</slot>
				<div style="margin-top:30px">
					<slot name="body">{{body}}</slot>
				</div>
				<div class="btns-container">
					<slot name="footer" v-bind="{close}">
        		<v-btn color="primary" v-if="on_accept" @click="on_accept">Aceptar</v-btn>
						<v-btn color="secondary" @click="close">{{close_btn_text}}</v-btn>
					</slot>
				</div>
			</slot>
    </v-card>
  </v-dialog>
</template>

<script>
/* agregar prop on_accept, q sea una funcion, si lo trae, mostrar un btn primary con este metodo, tambien on_accept_label */
export default {
  	props: {persistent:{default:true},id:{},max_width:{},align:{},title:{},template:{},body:{},on_accept:{},close_btn_text:{default:'Cancelar'}},
	data(){
		return { dialog: false }
	},
	computed:{
		dialogs() { return this.$store.getters.dialogs },
	},
	watch:{
		dialogs(){ this.dialog = this.dialogs.includes(this.id) },
		dialog(v) { if (!v && this.dialogs.includes(this.id)) this.close_dialog(this.id) },
	},
	created(){this.dialog = this.dialogs.includes(this.id)},
	methods:{
		close() { this.close_dialog(this.id) },
	}
};
</script>

<style scoped>
.fs1_dialog>.btns-container{ margin-top: 30px;}
</style>